module.exports = __webpack_public_path__ + "img/wedding_rings.d392a56.webp";